import { useEffect, useState } from "react";
import { _CreditAccountvdos } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { Alert } from "../../../../../../modules/theme/Component/Alert";
import { toast } from "react-toastify";
import { DetailsActiveCredits } from "./Components/DetailsActiveCredits";
import useModal, { MODAL_XL } from "../../../../../../modules/theme/Component/hooks/useModal";
import { MASK_DATE, MASK_MONEY, MASK_TEXT, MASK_TEXT_NOWRAP } from "../../../../../../modules/theme/Component/BasicTable";
import usePaginator from "../../../../../../modules/theme/Component/usePaginator";
import { _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import './ActiveCredits.css'
import { BasicButton } from "../../../../../../modules/theme/Component/BasicButton";
import { YearSelector } from "../../../../../../core/shared/inputs/YearSelector";
import { SelectMonths } from "../../../../../../modules/contract/select/SelectMonths";

interface Props {
    idAccount?: number;
}

interface formProps {
    Year: number;
    Month: number;
    State: number;
}

export const ActiveCredits = ({ idAccount }: Props) => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_CreditAccountvdos);
    const paginador = usePaginator();

    const [formdata, setFormData] = useState<Partial<formProps>>({
        Month: _single.getCurrentMonth(),
        Year: _single.getCurrenYear(),
    });

    useEffect(() => {
        if (idAccount) {
            getLista();
        }
    }, [idAccount, paginador.page]);

    const getLista = () => {
        const props: any = { IDAccount: idAccount };
        if (formdata.State) props.State = formdata.State;
        if (formdata.Month) props.Month = formdata.Month;
        if (formdata.Year) props.Year = formdata.Year;

        instance.getCarteraRender(paginador.page, 15, props).then(
            (resp) => {
                setLista(resp.List);
                paginador.setPages(resp.NumberOfPages);
            })
            .catch((err) => {
                toast.error(err);
            });
    }

    const estados = {
        725: { label: "Cancelado", color: "bg-danger" },
        724: { label: "Vigente", color: "bg-primary" },
        723: { label: "Aprobado", color: "bg-success" },
    };

    const returnEstado = (id: number) => estados[id] ?? { label: "No encontrado", color: "" };
    const [flippedIndex, setFlippedIndex] = useState<number | null>(null);

    return (
        <>
            <div className="row mb-4">
                {/* <div className="col-md-3">
                    <YearSelector onChange={(e) => { setFormData({ ...formdata, Year: e }) }} tittle="Año" value={formdata.Year} />
                </div>
                <div className="col-md-3">
                    <SelectMonths idSelector={formdata.Month} onChange={(e) => { setFormData({ ...formdata, Month: e }) }} label="Mes" />
                </div> */}
                <div className="col-md-3">
                    <label>Estado</label>
                    <select value={formdata.State} onChange={(e) => {
                        const value = e.target.value ? Number(e.target.value) : null;
                        setFormData({ ...formdata, State: value })
                    }} className="form-control">
                        <option value="">...</option>
                        <option value="725">Cancelado</option>
                        <option value="724">Vigente</option>
                        <option value="723">Aprobado</option>
                    </select>
                </div>
                <div className="col-md-3">
                    <BasicButton eventClick={() => { getLista() }} children={`Buscar`} useMargin icon="ri-seach-line" />
                </div>
            </div>
            <div className="row">
                <div className="col-md-4 d-flex justify-content-between align-items-center mb-3">
                    <button
                        className="btn btn-outline-primary btn-sm"
                        disabled={paginador.page <= 1}
                        onClick={() => paginador.back()}
                    >
                        Anterior
                    </button>

                    <span>
                        Página <strong>{paginador.page}</strong> de{" "}
                        <strong>{paginador.pages}</strong>
                    </span>

                    <button
                        className="btn btn-outline-primary btn-sm"
                        disabled={paginador.page >= paginador.pages}
                        onClick={() => paginador.next()}
                    >
                        Siguiente
                    </button>
                </div>

                <div className="col-md-12 cards-containerCredits">
                    {lista.length === 0 ? (
                        <div className="text-center">
                            <Alert clase="info" children={"No hay créditos disponibles"} />
                        </div>
                    ) : (
                        <>
                            {lista.map((item: any, index: number) => {
                                const props = item.DataBeanProperties;
                                const estado = returnEstado(props.State);

                                const isSelected = bean?.CreditNumber === props.CreditNumber;
                                const isFlipped = flippedIndex === index;

                                return (
                                    <div
                                        key={index}
                                        className={`credit-cardCredits ${isFlipped ? "flippedCredits selectedCredits" : ""} ${bean?.CreditNumber && !isSelected ? "dimmedCredits" : ""}`}
                                        onClick={() => {
                                            setBean(props);
                                            setFlippedIndex(isFlipped ? null : index);
                                        }}
                                    >
                                        <div className="card-innerCredits">
                                            {/* FRONT */}
                                            <div className="card-frontCredits">
                                                <h6 className="card-titleCredits">Crédito #{props.CreditNumber}</h6>

                                                <div className="rowCredits">
                                                    <span className="labelCredits">Estado:</span>
                                                    <span className="valueCredits">{estado.label}</span>
                                                </div>

                                                <div className="rowCredits">
                                                    <span className="labelCredits">Inicio:</span>
                                                    <span className="valueCredits" dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(props.FromDate, MASK_DATE) }} />
                                                </div>

                                                <div className="rowCredits">
                                                    <span className="labelCredits">Fin:</span>
                                                    <span className="valueCredits" dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(props.UptoDate, MASK_DATE) }} />
                                                </div>

                                                <div className="rowCredits">
                                                    <span className="labelCredits">Monto:</span>
                                                    <span className="valueCredits" dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(props.AmountCredit, MASK_MONEY) }} />
                                                </div>

                                                <div className="rowCredits">
                                                    <span className="labelCredits">Saldo:</span>
                                                    <span className="valueCredits" dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(props.CurrentCapitalLeft, MASK_MONEY), }} />
                                                </div>
                                            </div>

                                            {/* BACK */}
                                            <div className="card-backCredits">
                                                <h6 className="card-titleCredits">Detalles adicionales</h6>

                                                <div className="row">
                                                    <span className="labelCredits">Caja Nominadora:</span> <br />
                                                    <span className="valueCredits" dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(props.CajaNominadora, MASK_TEXT) }} />
                                                </div>

                                                <div className="rowCredits">
                                                    <span className="labelCredits">Tasa de Mora:</span>
                                                    <span className="valueCredits">
                                                        {props.RateValueMora} %
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </>
                    )}
                </div>

                <div className="col-12">
                    <hr />
                    <h6>Detalles del Crédito {bean.CreditNumber}</h6>
                </div>

                {bean.CreditNumber &&
                    <div className="col-md-12">
                        <DetailsActiveCredits _idAccount={idAccount} Credit={bean} />
                    </div>
                }
            </div>
        </>
    );
};
